Import icons from './icons';
Import toSvg from './to-svg';
Import replace from './replace';

module.Imports = { icons, toSvg, replace };
